import { StyledInput as Input } from './Input.styled';

export default Input;
